import React, { useCallback } from "react";
import { ErrorMessage } from "@components/atoms";
import * as S from "./styles";
export var NumberField = function NumberField(_ref) {
  var errors = _ref.errors,
      _onChange = _ref.onChange,
      value = _ref.value,
      disabled = _ref.disabled;
  return React.createElement(S.NumberField, null, React.createElement(S.Button, {
    type: "button",
    onClick: useCallback(function () {
      _onChange(value - 1);
    }, [_onChange, value]),
    disabled: disabled
  }, React.createElement("span", null, "\uFF0D")), React.createElement(S.Middle, null, React.createElement(S.Input, {
    onChange: function onChange(e) {
      return _onChange(parseInt(e.target.value, 10));
    },
    type: "number",
    value: value,
    disabled: disabled
  }), React.createElement(S.ErrorMessages, null, React.createElement(ErrorMessage, {
    errors: errors
  }))), React.createElement(S.Button, {
    type: "button",
    onClick: useCallback(function () {
      _onChange(value + 1);
    }, [_onChange, value]),
    disabled: disabled
  }, React.createElement("span", null, "\uFF0B")));
};